"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("./styles");
exports.Button = React.memo(function (props) {
    return (React.createElement("a", { href: props.href ? props.href : '#', className: styles_1.styles.button(props), onClick: function (evt) {
            if (props.onClick) {
                evt.preventDefault();
                props.onClick();
            }
        } }, props.children));
});
exports.Button.displayName = 'Button';
